import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchEventsConfig } from '@v2/pages/job/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const JobDetailsBatchEventsStack = createStackNavigator();

const JobDetailsBatchEventsNavigator = (props: any) => {
  return (
    <JobDetailsBatchEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchEventsConfig.map(({ Component, name }) => (
        <JobDetailsBatchEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </JobDetailsBatchEventsStack.Navigator>
  );
};

export { JobDetailsBatchEventsNavigator };
